import { ReactNode } from 'react'
import { ClickTrackingProvider, FormAnalyticsProvider, SessionDurationProvider } from '../../../../hooks'
import { AppointmentFormData } from '../../../../types'
import { IsConfigurationReadOnlyProvider } from '../useIsConfigurationReadOnly'
import { IsFormReadyProvider } from '../useIsFormReady'
import { SpecialistProvider } from '../useSpecialist'

interface Props {
  children: ReactNode
  isConfigurationReadOnly?: boolean
}

const Providers = ({ children, isConfigurationReadOnly }: Props) => (
  <IsConfigurationReadOnlyProvider isConfigurationReadOnly={isConfigurationReadOnly}>
    <SessionDurationProvider>
      <ClickTrackingProvider>
        <IsFormReadyProvider>
          <SpecialistProvider>
            <FormAnalyticsProvider<AppointmentFormData>>{children}</FormAnalyticsProvider>
          </SpecialistProvider>
        </IsFormReadyProvider>
      </ClickTrackingProvider>
    </SessionDurationProvider>
  </IsConfigurationReadOnlyProvider>
)

export { Providers }
